import { sharePointInternalFileName, sharePointInternalTitleName } from "../../config/constants";
import { FileOption } from "../../interfaces/IFileOption";
import { IFileToUpload } from "../../interfaces/IFileToUpload";
import { SharePointInputData } from "../../interfaces/props/SharePointInputData";

export const updateIndividualFileOptionsValue = (fileOptions: FileOption[], metadata: SharePointInputData[], changedIndex: number, titleAutoSetText: string) => {

    const changedInput = metadata.find(x => x.index === changedIndex);

    return fileOptions.map(fileOption => {
        return {
            ...fileOption,
            fileInputValues: fileOption.fileInputValues.map((inputValue, index) => {
                if (inputValue.internalName === changedInput?.internalName && !(inputValue.internalName === sharePointInternalTitleName && changedInput?.value === titleAutoSetText)) {
                    return { ...changedInput }
                }

                return { ...inputValue }

            })
        }
    });
}

export const updateFileName = (fileOptions: FileOption[], updatedFile: IFileToUpload) => {
    return fileOptions.map(fileOption => {
        if (updatedFile) {
            return {
                ...fileOption,
                updatedFile,
                text: updatedFile.name,
                fileInputValues: fileOption.fileInputValues.map(inputValue => {
                    let value = inputValue.value;
                    if (inputValue.internalName === sharePointInternalFileName) {
                        value = updatedFile.name;
                    }

                    return {
                        ...inputValue,
                        value
                    }
                })
            }
        }

        return {
            ...fileOption
        }
    })
}

export const fileCheckedToggled = (fileOptions: FileOption[], toggledFile: IFileToUpload, canOverwrite: boolean, inputValuesToSave: SharePointInputData[]) => {
    let updatedFileOptions: FileOption[] = [];
    const fileOption = fileOptions.find(x => x.key === toggledFile.id);
    if (toggledFile.isSelected) {
        if (!fileOption) {
            const newFileOption = {
                key: toggledFile.id,
                text: toggledFile.name,
                file: toggledFile,
                isSelectedFile: false,
                isModified: false,
                canOverwrite,
                isSaving: false,
                savingSuccess: false,
                savingError: false,
                fileInputValues: fileOptions[0].fileInputValues.map(inputValue => {
                    let originalInputValue = inputValuesToSave.find(x => x.internalName === inputValue.internalName)
                    let value;

                    if (inputValue.internalName === sharePointInternalFileName || inputValue.internalName === sharePointInternalTitleName) {
                        value = toggledFile.name;
                    } else {
                        value = originalInputValue?.value
                    }

                    if (originalInputValue) {
                        return {
                            ...originalInputValue,
                            value
                        }
                    }

                    return {
                        ...inputValue,
                        value
                    }

                }),
            }

            updatedFileOptions = [...fileOptions];
            updatedFileOptions.push(newFileOption);
        }
    }
    else {
        updatedFileOptions = fileOptions.filter(x => x.key !== toggledFile.id).map(fileOption => {
            return {
                ...fileOption
            }
        });
    }

    return updatedFileOptions;
}